import mixpanel from 'mixpanel-browser';
import { config } from '../config';
import { decodeIdToken, decodeMetadataToken } from '../utils/token.utils';
import { STORAGE_KEYS } from '../utils/storage.util';
import { jwtDecode } from 'jwt-decode';

class MixpanelService {
  private static initialized = false;

  private static isProductionEnv(): boolean {
    const e = (config.env || '').toLowerCase();
    return e === 'prod' || e === 'production';
  }

  public static init(userDetails: Record<string, unknown>): void {
    // if (!this.isProductionEnv() || !config.mixpanel_project_token) {
    //   return;
    // }
    
    const id = userDetails.id;
    if (id === undefined || id === null || id === '') {
      return;
    }

    if (!this.initialized) {
      mixpanel.init(config.mixpanel_project_token, {
        debug: false,
        persistence: 'localStorage',
        track_pageview: true,
      });
      this.initialized = true;
    }
    mixpanel.identify(String(id));
    mixpanel.people.set(userDetails);
  }

  /** Initialize from JWT / metadata already in storage (dashboard load). */
  public static initFromStoredTokens(): void {
    const decoded = decodeIdToken();
    const metadata = decodeMetadataToken();
    if (!decoded?.sub) {
      return;
    }
    const ew_jwt_token = localStorage.getItem(STORAGE_KEYS.EW_JWT_TOKEN);
    if (!ew_jwt_token) {
      return;
    }
    const decodedEwJwt = jwtDecode(ew_jwt_token);
    
    const ewData = (decodedEwJwt as any)?.data || {};
    const userId = ewData?.user_id;
    const company = metadata?.companies?.[0];
    const userDetails: Record<string, unknown> = {
      id: userId,
      $email: decoded.email,
      $first_name: decoded.given_name,
      $last_name: decoded.family_name,
      email: decoded.email,
      name: decoded.name,
      ...(company?.id != null ? { company_id: company.id } : {}),
    };
    this.init(userDetails);
  }

  public static track(eventName: string, properties: Record<string, unknown> = {}): void {
    // if (!this.isProductionEnv()) {
    //   return;
    // }
    mixpanel.track(eventName, properties);
  }

  public static incrementValue(property: string, by: number = 1): void {
    if (!this.isProductionEnv()) {
      return;
    }
    mixpanel.people.increment(property, by);
  }

  public static reset(): void {
    if (!this.initialized) {
      return;
    }
    mixpanel.reset();
    this.initialized = false;
  }
}

export default MixpanelService;
